export enum ToastType {
  Success = "Success",
  Warning = "Warning",
  Error = "Error",
  Information = "Information",
}

export enum OrderStatusButtonType {
  CANCEL = "CANCEL", // 취소 버튼
  RETURN = "RETURN", // 반품 버튼
  NONE = "NONE", // 버튼 없음
}

export enum OrderStatus {
  Refunded = "Refunded", // 환불 완료
  Canceled = "Canceled", // 주문 취소
  Partially = "Partially Refunded", // 부분 환불됨
  Completed = "Completed", // 주문 완료
  Return_Requested = "Return Requested", // 반품 접수됨
  Return_Approved = "Return Approved", // 반품 승인됨
  Shipped = "Shipped", // 발송 완료
  Partially_Shipped = "Partially Shipped", // 일부 발송 완료
  Partially_Preparing = "Partially Preparing", // 일부 배송 준비 중
  Preparing = "Preparing", // 배송 준비 중
  Scheduled = "ON HOLD", // 예약 발송 전
  Scheduled_Preparing = "Scheduled Preparing", // 예약 발송 준비 중
  Completed_Preparing = "Completed Preparing", // 예약 발송 완료
  PrizeCancel = "PrizeCancel", // 당첨 취소
  DrawCancel = "DrawCancel", // 응모 취소
  DrawLose = "DrawLose", // 미당첨
  DrawWin = "DrawWin", // 당첨
  DrawApply = "DrawApply", // 응모 완료
  Paid = "Paid", // 결제 완료
  Fulfilled = "Fulfilled",
  Unfulfilled = "Unfulfilled",
  Pending = "Payment Pending", // 결제 확인 중
  Gifting_Pending = "Gifting Pending", // 선물 수락 대기중
  Gifting_Accepted = "Gifting Accepted", // 선물 수락 완료
  None = "",
}

/** 반품 신청 화면 단계 */
export enum ReturnStep {
  Request = "request",
  Requested = "requested",
}

/** 반품 사유. Shopify ReturnReason 과 같은 값을 쓰며, 화면 문구는 앱의 번역 테이블에서 붙인다. */
export enum ReturnReason {
  DEFAULT = "DEFAULT",
  DEFECTIVE = "DEFECTIVE",
  UNWANTED = "UNWANTED",
  WRONG_ITEM = "WRONG_ITEM",
  SIZE_TOO_LARGE = "SIZE_TOO_LARGE",
  SIZE_TOO_SMALL = "SIZE_TOO_SMALL",
  OTHER = "OTHER",
}
